import {
  withTranslation,
} from 'react-i18next';

import RegattaCourseFieldsView from './RegattaCourseFieldsView';

const TranslatedComponent = withTranslation()(RegattaCourseFieldsView);

const Component = TranslatedComponent;

export default Component;
